import Rails from "@rails/ujs"
//REPLACE THIS with a Stimulus Controller
export const liveSearch = function() {
  // Listen for changes to forms with a livesearch class 
  // If support for new ajax added forms is required, get the ajax response to raise a liveSearchRefresh event

  const submitLiveSearch = (form) => { Rails.fire(form, "submit") }

  const liveSearchForms = document.querySelectorAll("form.livesearch");
    
  Array.from(liveSearchForms).forEach( function(f) {
    if (!f.classList.contains("listening")) {
      // Fires on keying or selecting
      f.addEventListener('input', function(event) {
        event.stopPropagation()
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          submitLiveSearch(f)
        }, 250)
      })
      f.addEventListener('select2Chosen', function(event) {
        //console.log("You select2 something")
        event.stopPropagation()
        submitLiveSearch(f)
      })
      f.classList.add("listening")
    }
  })

}


